import { createAxiosHttpClient } from "@ecommerce/http-setup";
import { userStorage } from "../utils/storage";
import { getStorefrontLogoutRedirectUrl } from "../utils/checkoutResumeAccess";

export const httpClient = createAxiosHttpClient({
    tenantName: "voda-argentina",
    authMode: "http-only-cookie",
    userStorage,
    onLogout: () => {
        userStorage.clear();
    },
    onSessionChanged: (event) => {
        if (typeof window === "undefined") return;
        window.dispatchEvent(
            new CustomEvent("voda:auth-session-changed", {
                detail: event,
            }),
        );
    },
    logoutRedirectUrl: getStorefrontLogoutRedirectUrl,
});

export const restoreStorefrontSession = async (): Promise<void> => {
    if (httpClient.getAccessToken() || !userStorage.get()) return;

    try {
        await httpClient.refreshSession();
    } catch {
        userStorage.clear();
    }
};
